module.exports = __webpack_public_path__ + "media/src/images/icons/alerts_emptystate-edef3f8b1024f69bada6600838d78c76.svg";